module.exports = __webpack_public_path__ + "media/6s-Yaruk-Chem.29499d60.mp4";